(function () {
  'use strict';

  var root = document.querySelector('[data-product-root]');
  var form = document.getElementById('pvProductForm');
  var dataNode = document.getElementById('pvProductData');
  if (!root || !form || !dataNode) return;

  var productData;
  try {
    productData = JSON.parse(dataNode.textContent);
  } catch (error) {
    return;
  }

  var variants = {};
  (productData.variants || []).forEach(function (variant) {
    variants[String(variant.id)] = variant;
  });

  var gallery = document.querySelector('[data-product-gallery]');
  var slides = gallery ? Array.from(gallery.querySelectorAll('[data-media-id]')) : [];
  var thumbs = gallery ? Array.from(gallery.querySelectorAll('[data-media-target]')) : [];
  var stage = gallery ? gallery.querySelector('[data-gallery-stage]') : null;
  var currentNode = gallery ? gallery.querySelector('[data-gallery-current]') : null;
  var zoomButton = gallery ? gallery.querySelector('[data-gallery-zoom]') : null;
  var dialog = document.getElementById('pvMediaDialog');
  var dialogImage = dialog ? dialog.querySelector('[data-dialog-image]') : null;
  var activeIndex = Math.max(0, slides.findIndex(function (slide) { return !slide.hidden; }));

  function pauseMedia(slide) {
    if (!slide) return;
    slide.querySelectorAll('video').forEach(function (video) { video.pause(); });
    slide.querySelectorAll('model-viewer').forEach(function (model) {
      if (model.pause) model.pause();
    });
  }

  function activateMedia(index, focusThumb) {
    if (!slides.length) return;
    activeIndex = (index + slides.length) % slides.length;

    slides.forEach(function (slide, slideIndex) {
      var active = slideIndex === activeIndex;
      if (!active) pauseMedia(slide);
      slide.hidden = !active;
      slide.classList.toggle('is-active', active);
    });

    thumbs.forEach(function (thumb, thumbIndex) {
      var active = thumbIndex === activeIndex;
      thumb.classList.toggle('on', active);
      thumb.setAttribute('aria-selected', active ? 'true' : 'false');
      thumb.tabIndex = active ? 0 : -1;
      if (active) {
        var strip = thumb.parentElement;
        if (strip && strip.scrollTo) {
          strip.scrollTo({
            left: Math.max(0, thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2),
            behavior: focusThumb ? 'smooth' : 'auto'
          });
        }
        if (focusThumb) thumb.focus({ preventScroll: true });
      }
    });

    if (currentNode) currentNode.textContent = String(activeIndex + 1);
    var activeSource = thumbs[activeIndex] || slides[activeIndex];
    var isImage = activeSource && activeSource.dataset.mediaKind === 'image';
    if (zoomButton) zoomButton.hidden = !isImage;
  }

  thumbs.forEach(function (thumb, index) {
    thumb.addEventListener('click', function () { activateMedia(index, false); });
    thumb.addEventListener('keydown', function (event) {
      var nextIndex = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = index + 1;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = index - 1;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = slides.length - 1;
      if (nextIndex === null) return;
      event.preventDefault();
      activateMedia(nextIndex, true);
    });
  });

  var previous = gallery ? gallery.querySelector('[data-gallery-prev]') : null;
  var next = gallery ? gallery.querySelector('[data-gallery-next]') : null;
  if (previous) previous.addEventListener('click', function () { activateMedia(activeIndex - 1, false); });
  if (next) next.addEventListener('click', function () { activateMedia(activeIndex + 1, false); });
  activateMedia(activeIndex, false);

  var pointerStart = null;
  if (stage) {
    stage.addEventListener('pointerdown', function (event) {
      if (event.target.closest('button, video, iframe, model-viewer')) return;
      pointerStart = { x: event.clientX, y: event.clientY };
    });
    stage.addEventListener('pointerup', function (event) {
      if (!pointerStart) return;
      var dx = event.clientX - pointerStart.x;
      var dy = event.clientY - pointerStart.y;
      pointerStart = null;
      if (Math.abs(dx) < 44 || Math.abs(dx) < Math.abs(dy)) return;
      activateMedia(dx < 0 ? activeIndex + 1 : activeIndex - 1, false);
    });
    stage.addEventListener('pointercancel', function () { pointerStart = null; });
  }

  if (zoomButton && dialog && dialogImage) {
    zoomButton.addEventListener('click', function () {
      var activeSource = thumbs[activeIndex] || slides[activeIndex];
      if (!activeSource || !activeSource.dataset.fullSrc) return;
      dialogImage.src = activeSource.dataset.fullSrc;
      dialogImage.alt = activeSource.dataset.mediaAlt || '';
      if (dialog.showModal) dialog.showModal();
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
    var closeDialog = dialog.querySelector('[data-dialog-close]');
    if (closeDialog) closeDialog.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('close', function () {
      dialogImage.removeAttribute('src');
      zoomButton.focus();
    });
  }

  var select = document.getElementById('pvVariantSelect');
  var quantity = document.getElementById('pvQty');
  var price = document.getElementById('pvPrice');
  var compareAt = document.getElementById('pvWasPrice');
  var save = document.getElementById('pvSavePrice');
  var addButton = document.getElementById('pvAtc');
  var buyButton = document.getElementById('pvBuyNow');
  var sticky = document.getElementById('pvStickyAtc');
  var stickyButton = document.getElementById('pvStickyAtcBtn');
  var stickyPrice = document.getElementById('pvStickyPrice');
  var toast = document.getElementById('pvCartToast');

  function setButtonState(button, available, text) {
    if (!button) return;
    button.disabled = !available;
    button.setAttribute('aria-disabled', available ? 'false' : 'true');
    button.textContent = available ? text : 'Sold Out';
  }

  function updateVariant() {
    if (!select) return;
    var variant = variants[String(select.value)];
    if (!variant) return;

    if (price) price.textContent = variant.price;
    if (stickyPrice) stickyPrice.textContent = variant.price;
    if (compareAt) {
      compareAt.textContent = variant.compareAt || '';
      compareAt.hidden = !variant.compareAt;
    }
    if (save) {
      save.textContent = variant.savePercent ? 'Save ' + variant.savePercent + '%' : '';
      save.hidden = !variant.savePercent;
    }
    setButtonState(addButton, variant.available, 'Add to Cart');
    setButtonState(buyButton, variant.available, 'Buy Now | Instant Checkout');
    setButtonState(stickyButton, variant.available, 'Add to Cart');

    if (variant.mediaId) {
      var mediaIndex = slides.findIndex(function (slide) {
        return String(slide.dataset.mediaId) === String(variant.mediaId);
      });
      if (mediaIndex >= 0) activateMedia(mediaIndex, false);
    }

    if (variant.url && window.history && window.history.replaceState) {
      window.history.replaceState({ variant: variant.id }, '', variant.url);
    }
  }

  if (select && select.tagName === 'SELECT') select.addEventListener('change', updateVariant);

  var minus = root.querySelector('[data-qty-minus]');
  var plus = root.querySelector('[data-qty-plus]');
  if (minus) minus.addEventListener('click', function () {
    quantity.value = String(Math.max(1, (parseInt(quantity.value, 10) || 1) - 1));
  });
  if (plus) plus.addEventListener('click', function () {
    quantity.value = String(Math.min(99, (parseInt(quantity.value, 10) || 1) + 1));
  });

  function showToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    window.setTimeout(function () { toast.classList.remove('show'); }, 3000);
  }

  function updateCartBadge() {
    fetch(productData.routes.cart + '.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.querySelectorAll('.pv-cart-dot, .fluid-header__cart b').forEach(function (dot) {
          dot.textContent = cart.item_count;
          dot.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
        document.querySelectorAll('a[href="/cart"], .fluid-header__cart').forEach(function (link) {
          link.setAttribute('aria-label', 'Cart, ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items'));
        });
      })
      .catch(function () {});
  }

  var cartPending = false;
  form.addEventListener('submit', function (event) {
    if (cartPending) { event.preventDefault(); return; }
    if (event.submitter && event.submitter.name === 'checkout') return;
    event.preventDefault();
    if (!addButton || addButton.disabled || !select) return;

    cartPending = true;
    var originalText = addButton.textContent;
    addButton.textContent = 'Adding…';
    addButton.disabled = true;

    fetch(productData.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(select.value), quantity: Math.max(1, parseInt(quantity.value, 10) || 1) })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Unable to add. Please try again.');
          return data;
        });
      })
      .then(function () {
        showToast('Added to cart');
        updateCartBadge();
        addButton.textContent = 'Added';
        window.setTimeout(function () {
          cartPending = false;
          updateVariant();
        }, 1800);
      })
      .catch(function (error) {
        showToast(error.message || 'Unable to add. Please try again.');
        cartPending = false;
        updateVariant();
      });
  });

  if (stickyButton && addButton) {
    stickyButton.addEventListener('click', function () { form.requestSubmit(addButton); });
    if ('IntersectionObserver' in window) {
      var stickyObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var passedMainButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('pv-sticky-atc--visible', passedMainButton);
          sticky.setAttribute('aria-hidden', passedMainButton ? 'false' : 'true');
        });
      });
      stickyObserver.observe(addButton);
    }
  }
})();
